import { ApolloProvider } from "@apollo/client";
import type { FC, ReactNode } from "react";

import { useServer } from "@shared/hooks";

import { useClient } from "./useClient";

interface Props {
  children: ReactNode;
}

const ApolloClientProvider: FC<Props> = ({ children }) => {
  const client = useClient();
  const { ssr, apolloClient } = useServer();

  return <ApolloProvider client={ssr ? apolloClient : client}>{children}</ApolloProvider>;
};

export { ApolloClientProvider };
